/*

React(DOM) puts everything to global namespace as a fallback.
TypeScript's module=UMD gets close but lacks the fallback. So let's hack that.

REACT:

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.React = {}));
}(this, (function (exports) { 'use strict';

"UMD" (the `require` arg is unused):

(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports"], factory);
    }

This was also "almost there":
<script> *var exports = {};* </script>
https://stackoverflow.com/questions/43042889/typescript-referenceerror-exports-is-not-defined/56478107#56478107
*/

// self === Window
// NOTE: this is a single namespace – but whatever
exports = self._workaround_umd_exports = self; // {};

//  XXX: now we’re getting a const jsx_runtime_1 = require("react/jsx-runtime");
//       which is already exported to the global scope/namespace (on Window)
//       so let’s make the stuff (currently: Fragment, jsx, jsxs) available
//       to our modules
//  XXX: importing all of Window properties and exporting them later lead to
//       an immediate refresh – probably due to setting window.location
//  XXX: so rather load just the minimum necessary

// TODO: since `exports` is now aliased to self/window we can drop this part
// NOPE: BookTypeEnum (the source file is not a module yet)
var importedSymbols = `
    Dropzone
    Fragment
    he
    React
    ReactDOM
    jsx
    jsxs

    BookPage
    Device
    ReaderPagination
    ReaderPanelEnum

    activateTooltips
    replaceSpecialChars
    updateQueryStringParameter

    bibliographyModule
`.trim().split(/\s+/);

for (let name of importedSymbols) {
    // NOTE: `exports` is now simply the same as `self` (`window`)
    if (exports[name]) {
        console.warn(`${name} already imported/hacked, skipping`);
        continue;
    }

    exports[name] = self[name];
}

// Make React hooks also available on the global object to enable idiomatic
// imports to work
var namespaces = {
    React: `
        useRef
        useState
    `.trim().split(/\s+/),

}

for (let [ns, symbols] of Object.entries(namespaces)) {
    const namespace = exports[ns];

    for (let name of symbols) {
        const value = namespace[name];

        // NOTE: `exports` is now simply the same as `self` (`window`)
        exports[name] = value;
    }
}

// NOTE: `exports` is now simply the same as `self` (`window`)
module = {};
module.exports = exports;

var defaultImportState = {
    moduleName: null,
};

require = (modulePath) =>
{
    console.log(
        `workaround: require(${modulePath})`
        // + ` from ${__modulePath}`
    );

    //  XXX: this is a workaround for __importDefault
    //
    //       import Button from 'react-bootstrap/Button';
    //       <Button />
    //
    //       const Button_1 = __importDefault(require("react-bootstrap/Button"));
    //       jsx_runtime_1.jsxs(Button_1.default, {})
    const moduleNamePosition = modulePath.lastIndexOf('/');
    const moduleName = modulePath.slice(moduleNamePosition + 1);

    const value = exports[moduleName];

    if (value) {
        console.log(
            `workaround: ${moduleName} might be a default export (and we ` +
            `need to assume that the symbol name matches the module name!)`);

        /*
        return {
            __esModule: true,
            default: value,
        };
        */

        defaultImportState.moduleName = moduleName;
    }

    // DONE: we shouldn’t need to populate this limited “global” object manually
    //       with importedSymbols; let’s just use the actual global object and
    //       be done with it…

    // NOTE: `exports` is now simply the same as `self` (`window`)
    return exports;
};

// NOTE: `mod` is also (always) just the exports/self/window global namespace
__importDefault = (mod) =>
{
    const symbolName = defaultImportState.moduleName;

    console.log(
        `workaround: returning the assumed default export (${symbolName})`);

    const value = mod[symbolName];

    return {
        __esModule: true,
        default: value,
    };
};
